// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NoNa","title":"styles_title__3dGtY"};